import {RcfaComplianceLocationNode} from '@domain/rcfa'
import {FlexPage} from '@hconnect/common/components'
import {useExpandedState} from '@hconnect/common/hooks'
import {getSystemTimezone} from '@hconnect/common/utils'
import {Grid} from '@mui/material'
import {useMemo} from 'react'

import {RcfaComplianceHeaderActions} from '../components'
import {RcfaComplianceContainer} from '../containers'
import {useRcfaCompliancePageState} from '../hooks'
import {getAllItemIds} from '../utils'

type Props = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  data: RcfaComplianceLocationNode[] | undefined
  onPlantItemClick: (plantId: string) => void
  inverted?: boolean
}

export const RcfaComplianceTableView = ({
  titleSlot,
  aboveTitleSlot,
  data,
  onPlantItemClick,
  inverted = false
}: Props) => {
  const {plantView, setPlantView, timeRange, setTimeRange} = useRcfaCompliancePageState()
  const timezone = getSystemTimezone()

  const allItemsIds = useMemo(() => getAllItemIds('subLocations', data ?? []), [data])

  const {allExpanded, getIsExpanded, toggleExpandCollapse, toggleExpandCollapseAll} =
    useExpandedState(allItemsIds)

  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      nameBodySx={{
        width: '100%'
      }}
      headerActionContent={
        <Grid spacing={1} container alignItems="center" justifyContent="flex-end">
          <Grid item>
            <RcfaComplianceHeaderActions
              timeRange={timeRange}
              setTimeRange={setTimeRange}
              allExpanded={allExpanded}
              toggleExpandCollapseAll={toggleExpandCollapseAll}
              plantView={plantView}
              setPlantView={setPlantView}
              timezone={timezone}
              inverted={inverted}
            />
          </Grid>
        </Grid>
      }
    >
      <RcfaComplianceContainer
        plantView={plantView}
        timeRange={timeRange}
        timezone={timezone}
        getIsExpanded={getIsExpanded}
        toggleExpandCollapse={toggleExpandCollapse}
        onPlantItemClick={onPlantItemClick}
      />
    </FlexPage>
  )
}
